var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('banner'),(!_vm.$config.needElectronicContract)?_c('flexible-investment'):_vm._e(),_c('fixed-investment'),_c('trust'),_c('products'),_c('investors'),_c('media'),_c('footer-bar'),_c('activity-popup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }